import http, { gw } from "./client";

interface ISavePushTokenParams {
  authorization: {
    host: string;
    authToken: string;
  };
  payload: {
    type: string;
    device: string;
    code: string;
  }
}

interface ISavePushTokenResponse {
  status: string;
}

export async function savePushToken(params: ISavePushTokenParams): Promise<ISavePushTokenResponse> {
  const response = await gw.post(`/notification/push`, 
    params.payload, 
    {
      headers: {
        "Authorization": `Bearer ${params.authorization.authToken}`,
        "X-App-Host": params.authorization.host,
    }
  });
  return response.data;
}